import { render, staticRenderFns } from "./LiveChatTreeNode.vue?vue&type=template&id=c2be1138&scoped=true&"
import script from "./LiveChatTreeNode.vue?vue&type=script&lang=js&"
export * from "./LiveChatTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatTreeNode.vue?vue&type=style&index=0&id=c2be1138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2be1138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSelect,VTooltip})
